export default "__VITE_ASSET__CIxS7ysa__"